import { call, put, takeLatest } from 'redux-saga/effects';

import { getSystemMessages as getSystemMessagesApi } from '../../services';
import { checkOnline } from '../notifications';
import { REQUEST_SYSTEM_MESSAGES, receiveSystemMessages } from './actions';

export function* doRequestSystemMessages() {
  try {
    const { values: systemMessages } = yield call(getSystemMessagesApi);
    yield put(receiveSystemMessages(systemMessages));
  } catch (err) {
    yield console.error(err);
    yield call(checkOnline);
  }
}

export const sagas = [takeLatest(REQUEST_SYSTEM_MESSAGES, doRequestSystemMessages)];
